<template>
  <div class="speaker">
    <h3 class="speaker__title">{{ dataSpeaker.title }}</h3>
    <h4 class="speaker__subtitle">{{ dataSpeaker.subtitle }}</h4>
    <p class="speaker__description" v-html="dataSpeaker.bio"></p>
    <ul class="speaker__social">
      <li v-if="dataSpeaker.twitter !== ''">
        <a class="ui-link" :href="dataSpeaker.twitter" data-hover="Twitter" rel="noopener" target="_blank">Twitter</a>
      </li>
      <span v-if="dataSpeaker.twitter !== '' && dataSpeaker.website !== ''">  –  </span>
      <li v-if="dataSpeaker.website !== ''">
        <a class="ui-link" :href="dataSpeaker.website" data-hover="Website" rel="noopener" target="_blank">Website</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BasePicture from '@/components/BasePicture';


export default {
  name: 'speaker',

  components: {
    BasePicture,
  },

  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      currentSpeaker: 'getSpeakerName',
    }),

    dataSpeaker() {
      const speaker = this.data.find(el => el.path === `/${this.currentSpeaker}`);

      // if (speaker === undefined && this.getSpeakerName !== undefined) this.$eventHub.$emit('redirect404');
      return speaker;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

.speaker {
  position: relative;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-flow: row wrap;

  padding: 0 0 100px;

  @include mq(ipadP) {
    padding: 0;
  }

  &__title {
    width: 100%;
    @include mq($until: ipadP) {
      font-size: font-size(l);
    }
  }

  &__subtitle {
    margin-top: 5px;
    margin-bottom: 30px;
    font-size: font-size(s);
    text-transform: uppercase;
    letter-spacing: 2px;
  }

  &__description {
    margin-bottom: 30px;
  }

  &__social li,
  &__social span {
    display: inline-block;
  }
}
</style>
